<template>
  <footer class="mt-5 mb-2">
      <hr/>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                2021 Created by Faysal Fadel Maulana
            </div>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style>

</style>